import { render, staticRenderFns } from "./JobReferredByChanged.vue?vue&type=template&id=755cd8e8"
import script from "./JobReferredByChanged.vue?vue&type=script&lang=js"
export * from "./JobReferredByChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports